import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to call a function when the user navigates away from the current path.
 * @param callback {Function} The callback function.
 * @returns void
 */
export const useOnNavigateAway = (callback: Function) => {
  const { pathname: currentPathname } = useLocation();
  const [initialPathname] = useState(currentPathname);

  useEffect(() => {
    if (initialPathname !== currentPathname) {
      callback();
    }
  }, [initialPathname, currentPathname, callback]);
};
